import { render, staticRenderFns } from "./FullWidthLayout.vue?vue&type=template&id=a8158a62"
import script from "./FullWidthLayout.vue?vue&type=script&lang=js"
export * from "./FullWidthLayout.vue?vue&type=script&lang=js"
import style0 from "./FullWidthLayout.vue?vue&type=style&index=0&id=a8158a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports